export const GetSftpFileDocumentation = `
# Get SFTP File


`;
